export default __webpack_public_path__ + "static/media/compass.af81e567.svg";